import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import './App.css';

import theme from './utility/theme';

import NavBar from './NavBar';
import Page from './Page';


const styles = theme => ({
  container: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    marginTop: theme.spacing.unit * 3,
  }
});


function App(props){
  return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <NavBar />
        <Grid container justify="center" className={props.classes.container}>
          <Page style={{marginBottom: 150}} />
        </Grid>
      </MuiThemeProvider>
  );
}

export default withStyles(styles)(App);


// WEBPACK FOOTER //
// ./src/App.js